import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Eyebrow, Section } from '../ui/Section';
const faqs = [{
  q: '¿Cómo recibo el kit?',
  a: 'Acceso inmediato por PDF digital apenas se acredita el pago.'
}, {
  q: '¿Sirve si recién empiezo?',
  a: 'Sí. Arranca desde los fundamentos y llega hasta los casos complejos.'
}, {
  q: '¿Necesito productos caros?',
  a: 'No. Con tu maletín habitual alcanza para aplicar todo el contenido.'
}, {
  q: '¿Incluye los 6 bonos?',
  a: 'Sí, ambas opciones incluyen los 6 bonos completos.'
}, {
  q: '¿Sirve para estudio, domicilio y eventos?',
  a: 'Sí, está pensado para cualquier contexto de trabajo.'
}, {
  q: '¿Sirve para cualquier tono de piel?',
  a: 'Sí, el Tomo 5 cubre piel madura, oscura, clara y con acné activo.'
}, {
  q: '¿Qué diferencia tiene con tutoriales gratis?',
  a: 'Acá tenés un sistema completo y ordenado, de fundamentos a corrección aplicada.'
}, {
  q: '¿Por qué elegir el Megapack?',
  a: 'Suma armonías del color y colorimetría para eventos, ideal para novias o nivel técnico superior.'
}, {
  q: '¿La garantía es real?',
  a: 'Sí. Tenés 7 días para probarlo y pedir el reembolso completo.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  const [showAll, setShowAll] = useState(false);
  const visibleFaqs = showAll ? faqs : faqs.slice(0, 5);
  return <Section className="bg-blush" data-id="element-72" data-mp="37fozdtgi1413"><div className="mx-auto max-w-2xl text-center" data-id="element-73" data-mp="37evoqhef5udo"><Eyebrow data-id="element-74" data-mp="32i58nu2m6ys9">Preguntas frecuentes</Eyebrow><h2 className="mt-2 font-display text-3xl font-semibold leading-tight text-ink sm:mt-3 sm:text-4xl" data-id="element-75" data-mp="32h3wfm9v468y">Resolvemos tus dudas</h2></div><div className="mx-auto mt-6 max-w-3xl space-y-2 sm:mt-10 sm:space-y-3" data-id="element-76" data-mp="3hcjvk5pausc7">{visibleFaqs.map((faq, index) => {
        const isOpen = open === index;
        return <div key={faq.q} className="overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-rosegold/10 sm:rounded-2xl" data-id="element-77" data-mp="1n03iaky36dxu" data-mpi={index}><button onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center gap-3 px-4 py-3 text-left sm:gap-4 sm:px-5 sm:py-4" data-id="element-78" data-mp="1i33lz1r1gpjx"><span className="flex-1 text-sm font-medium leading-snug text-ink sm:text-base" data-id="element-79" data-mp="2br9cf9x2hz00">{faq.q}</span><ChevronDownIcon className={`h-4 w-4 shrink-0 text-rosegold transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-80" data-mp="2gqvrzq0dbrbz" /></button><AnimatePresence initial={false} data-id="element-81" data-mp="2lpyx1agclxjy">{isOpen && <motion.p initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="border-t border-blush px-4 py-3 text-xs leading-relaxed text-plum sm:px-5 sm:py-4 sm:text-sm" data-id="element-82" data-mp="2lr07bcpjig0m">{faq.a}</motion.p>}</AnimatePresence></div>;
      })}</div>{!showAll && <button onClick={() => setShowAll(true)} className="mx-auto mt-4 flex items-center gap-1.5 text-xs font-semibold text-rosegold sm:mt-6" data-id="element-83" data-mp="2zhn6f5z7q7x8">Ver las {faqs.length - visibleFaqs.length} preguntas restantes <ChevronDownIcon className="h-3.5 w-3.5" data-id="element-84" data-mp="39guna355okp3" /></button>}</Section>;
}